/** @type {() => typeof import("./reducer.js").initState} */
const selectRoot = (state) => state.settings.permission;

export const selectPermissionUserList = (state) => selectRoot(state).permissionUserList;
